//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MoominQuote",
  props: {
    image: {
      type: Object,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "var(--c-secondary)",
    },
    background: {
      type: String,
      default: "",
    },
  },
};
